export const DEFAULT_LOCALE = "en";

export function getMessages(locale) {
  try {
    return require(`../../i18n/${locale}.json`);
  } catch (error) {
    return require(`../../i18n/${DEFAULT_LOCALE}.json`);
  }
}
